<article>
    <section class="top-section pl-6 pr-6 d-flex flex-row align-items-end">
        <div class="col-12 col-sm col-lg-8 p-0 pr-6">
            <h1 class="mb-6 text-center text-sm-left selenium-page-title">404</h1>
            <div class="description">
                <span *ngIf="learningObjects.length === 0">
                    We can’t seem to find the page you’re looking for. Check to see if that address
                    is correct {{ (!isAddOnView && "or try search.") || "." }}
                </span>
                <span *ngIf="learningObjects.length > 0"
                    >This resource is no longer available.
                    {{
                        (!isAddOnView &&
                            "Try a keyword search, or check out similar resources below.") ||
                            ""
                    }}
                </span>
            </div>
            <app-external-search-input
                *ngIf="!isAddOnView"
                class="d-block"
                placeholder="Search Keyword(s)"
            ></app-external-search-input>
        </div>
        <div>
            <img class="error-img d-none d-sm-block" [src]="image" />
        </div>
    </section>
    <section class="bottom-section w-100 pb-2" *ngIf="!isAddOnView">
        <app-subject-list
            class="d-block pl-6 pr-6"
            [subjects]="subjects"
            *ngIf="learningObjects.length === 0"
        ></app-subject-list>
        <app-resource-list
            class="d-flex flex-wrap justify-content-between ml-2 mr-2"
            *ngIf="learningObjects.length > 0"
            [learningObjects]="learningObjects"
        ></app-resource-list>
    </section>
</article>
